import React, { useEffect, useState } from "react";
import { fetchMeetupspagelist } from "../services/Meetupspagelist";
import { API_BASE } from "../api/apiConfig";
import { Navigation, Thumbs, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';

const Communityupcomingmeet = () => {
  const [meetups, setMeetups] = useState([]);
  const [filteredMeetups, setFilteredMeetups] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [city, setCity] = useState("All");
  const [viewMode, setViewMode] = useState("all"); // all | city
  const [loading, setLoading] = useState(true);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  /* ================= API LOAD ================= */
  useEffect(() => {
    loadMeetups();
  }, []);

  const loadMeetups = async () => {
    try {
      const res = await fetchMeetupspagelist();
      if (res?.status) {
        setMeetups(res.data);
        setFilteredMeetups(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    let data = [...meetups];

    if (search) {
      data = data.filter(
        (item) =>
          item.heading.toLowerCase().includes(search.toLowerCase()) ||
          item.city.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "All") {
      data = data.filter((item) =>
        JSON.parse(item.category).includes(category)
      );
    }

    if (city !== "All") {
      data = data.filter((item) => item.city === city);
    }

    setFilteredMeetups(data);
  }, [search, category, city, meetups]);

  if (loading) {
    return <p className="text-center py-10">Loading meetups...</p>;
  }

  /* ================= GROUP BY CITY ================= */
  const groupedByCity = filteredMeetups.reduce((acc, item) => {
    acc[item.city] = acc[item.city] || [];
    acc[item.city].push(item);
    return acc;
  }, {});

  
  const images = [
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/sydney-event-718dPIskbatRbpERJbKB2VtOE6mx27.jpg',
      title: 'Tokyo Sakura Festival Meetup',
      participants: '45',
      location: 'Tokyo, Japan',
      date: 'April 2023',
      tags: ['Cultural', 'Photography', 'Seasonal'],
      quote: `"The local insights we gained were incredible. This wasn't just sightseeing—it was true cultural immersion."`,
      author: 'Emma W.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
  ];

  const stripHtml = (html) => {
    return html ? html.replace(/<[^>]*>/g, "") : "";
  };

  const sliderData = filteredMeetups.slice(0, 6).map((item) => ({
    src: `${API_BASE}/${item.image}`,
    title: item.heading,
    participants: item.spots || "0",
    location: item.city,
    date: item.date,
    tags: item.category ? JSON.parse(item.category) : [],
    quote: stripHtml(item.local_experts_details?.[0]?.about),
    author: item.local_experts_details?.[0]?.name || "Guest",
  }));

  return (

    <div class="md:block swiper-thumbnailslider">
      <div class="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
          <div class="relative overflow-hidden rounded-xl md:col-span-2 lg:col-span-3">
              <div className="relative overflow-hidden rounded-xl md:col-span-2 lg:col-span-3">
                  <Swiper
                      modules={[Navigation, Thumbs, Pagination]}
                      thumbs={{ swiper: thumbsSwiper }}
                      navigation={{
                          nextEl: '.custom-next',
                          prevEl: '.custom-prev',
                      }}
                      pagination={{
                          el: '.custom-pagination',
                          clickable: true,
                      }}
                      className="aspect-[16/9]"
                  >
                      {sliderData.map((img, index) => (
                      <SwiperSlide key={index}>
                          <div className="">
                          <img className="object-cover w-full h-full" src={img.src} alt={img.title} />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                          <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                              <div className="flex flex-wrap items-center gap-2">
                                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white"> {img.participants} Participants </div>
                                  <div className="flex items-center gap-1 rounded-full bg-black/50 px-2 py-1 text-xs text-white backdrop-blur-sm">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-3 w-3 text-primary">
                                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                          <circle cx="12" cy="10" r="3"></circle>
                                      </svg>
                                      {img.location}</div>
                                  <div className="flex items-center gap-1 rounded-full bg-black/50 px-2 py-1 text-xs text-white backdrop-blur-sm">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar h-3 w-3 text-primary">
                                          <path d="M8 2v4"></path>
                                          <path d="M16 2v4"></path>
                                          <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                                          <path d="M3 10h18"></path>
                                      </svg>
                                      {img.date}
                                  </div>
                              </div>
                              <h4 className="mt-2 text-xl font-bold text-white md:text-2xl">{img.title}</h4>
                              <div className="flex flex-wrap gap-1 mt-2">
                                  {img.tags.map((tag, i) => (
                                      <span key={i} className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-white/30 bg-black/30 text-white backdrop-blur-sm">{tag}</span>
                                  ))}
                              </div>
                              <div className="mt-3 rounded-lg bg-black/40 p-3 backdrop-blur-sm md:max-w-[80%]">
                              <p className="text-sm italic text-white"> {img.quote} </p>
                              <p className="text-xs mt-1 font-medium text-primary">— {img.author}</p>
                              </div>
                          </div>
                          </div>
                      </SwiperSlide>
                      ))}
                  </Swiper>
                  <button
                      class="custom-prev absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-slate-800 shadow-md transition-all duration-300 hover:bg-primary hover:text-white"
                      aria-label="Previous activity"
                      >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-chevron-left h-5 w-5"
                      >
                          <path d="m15 18-6-6 6-6"></path>
                      </svg>
                  </button>
                  <button
                      class="custom-next absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-slate-800 shadow-md transition-all duration-300 hover:bg-primary hover:text-white"
                      aria-label="Next activity"
                      >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-chevron-right h-5 w-5"
                      >
                          <path d="m9 18 6-6-6-6"></path>
                      </svg>
                  </button>
              </div>
              <div class="custom-pagination flex items-center justify-center gap-2 border-t border-slate-100 bg-white p-2 mt-2"></div>
          </div>
         <div class="flex flex-col gap-4 meetups-box">
             <div class="rounded-lg border bg-card text-card-foreground shadow-sm border-primary/20 bg-gradient-to-br from-primary/10 to-white" data-v0-t="card">
                  <div class="p-4">
                      <div class="flex items-center gap-2 text-primary">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-5 w-5">
                              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                              <circle cx="9" cy="7" r="4"></circle>
                              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                          </svg>
                          <h4 class="font-bold">Why Join Our Meetups?</h4>
                      </div>
                      <ul class="mt-3 space-y-2 text-sm">
                          <li class="flex items-start gap-2">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-heart mt-0.5 h-4 w-4 flex-shrink-0 text-primary"
                              >
                                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                              </svg>
                              <span>Connect with like-minded travelers</span>
                          </li>
                          <li class="flex items-start gap-2">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-globe mt-0.5 h-4 w-4 flex-shrink-0 text-primary"
                              >
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                                  <path d="M2 12h20"></path>
                              </svg>
                              <span>Discover hidden gems with local insights</span>
                          </li>
                          <li class="flex items-start gap-2">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-message-square mt-0.5 h-4 w-4 flex-shrink-0 text-primary"
                              >
                                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                              </svg>
                              <span>Share stories and create lasting memories</span>
                          </li>
                          <li class="flex items-start gap-2">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-camera mt-0.5 h-4 w-4 flex-shrink-0 text-primary"
                              >
                                  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                                  <circle cx="12" cy="13" r="3"></circle>
                              </svg>
                              <span>Experience authentic cultural moments</span>
                          </li>
                      </ul>
                      <button
                          class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 py-2 mt-4 w-full bg-primary text-white hover:bg-primary/90"
                      >
                          Join Next Meetup
                          {/*<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right ml-1 h-4 w-4">
                              <path d="M5 12h14"></path>
                              <path d="m12 5 7 7-7 7"></path>
                          </svg>*/}
                      </button>
                  </div>
              </div>


             <div class="rounded-lg border border-slate-200 bg-white p-3">
              <h4 class="mb-2 font-bold text-slate-800">Upcoming Meetups</h4>
              <div class="space-y-2">

                {filteredMeetups.slice(0, 3).map((item) => (
                  <div class="flex gap-2 rounded-lg border border-slate-100 bg-slate-50 p-2">
                      <div class="relative h-12 w-12 flex-shrink-0 overflow-hidden rounded-md">
                          <img
                              alt={item.city}
                              loading="lazy"
                              decoding="async"
                              data-nimg="fill"
                              class="object-cover"
                              src={`${API_BASE}/${item.image}`}
                          />
                      </div>
                      <div class="flex-1">
                          <h5 class="text-xs font-bold text-slate-800">Paris Evening Stroll</h5>
                          <p class="flex items-center gap-1 text-xs text-slate-500">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar h-3 w-3">
                                  <path d="M8 2v4"></path>
                                  <path d="M16 2v4"></path>
                                  <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                                  <path d="M3 10h18"></path>
                              </svg>
                              {item.date}
                          </p>
                      </div>
                  </div>
               ))}

              </div>
              <a href="/meetups" 
                  class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 underline-offset-4 hover:underline mt-1 h-auto p-0 text-xs text-primary"
              >
                  View all upcoming meetups
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right ml-1 h-3 w-3">
                      <path d="m9 18 6-6-6-6"></path>
                  </svg>
              </a>
          </div>

          </div>

          </div>
               <Swiper
              modules={[Thumbs]}
              watchSlidesProgress
              onSwiper={setThumbsSwiper}
              spaceBetween={10}
              className="mt-6"
              breakpoints={{
                0: {
                  slidesPerView: 1.8, // Mobile — active + partial next
                },
                480: {
                  slidesPerView: 2.2,
                },
                640: {
                  slidesPerView: 2.8,
                },
                768: {
                  slidesPerView: 3.5,
                },
                1024: {
                  slidesPerView: 4.6,
                },
                1280: {
                  slidesPerView: 5,
                },
              }}
            >
              {sliderData.map((img, index) => (
                <SwiperSlide
                  key={index}
                  className="click relative cursor-pointer overflow-hidden rounded-lg border border-primary ring-1 ring-primary/20 transition-all duration-300"
                >
                  <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg border border-slate-200 hover:border-primary transition">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="object-cover w-full h-full"
                    />

                    <div className="absolute inset-0 transition-opacity" />

                    <div className="absolute bottom-0 left-0 right-0 p-2">
                      <p className="text-xs font-medium text-white line-clamp-1">
                        {img.title}
                      </p>
                      <div className="flex items-center gap-1 text-xs text-slate-200">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-2.5 w-2.5 text-primary"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        {img.location}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
     </div>
  );
};

export default Communityupcomingmeet;
